<template>
  <div class="resignPersonnel">
    <HearderTitle name="离职员工" />
    <div class="tableBox">
      <div class="tool_bar">
        <el-form :inline="true" :model="queryInfo">
          <el-form-item>
            <el-input v-model="queryInfo.pername" placeholder="姓名/手机号"></el-input>
          </el-form-item>
          <el-form-item label="所属部门" prop="dep_id" class="dep_id">
            <el-select v-model="queryInfo.dep_id" placeholder="请选择" ref="selectTree" clearable>
              <el-option :key="queryInfo.dep_id" :value="queryInfo.dep_id" :label="queryInfo.dep_id" hidden> </el-option>
              <el-tree :data="datalist" :props="defaultProps" @node-click="handleClickNode" :default-expand-all="true" node-key="id"></el-tree>
            </el-select>
          </el-form-item>
          <el-form-item label="离职日期">
            <el-date-picker v-model="queryInfo.lzdayet" prefix-icon=" " align="right" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"> </el-date-picker>
            <span class="middle">到</span>
            <el-date-picker v-model="queryInfo.lzdayst" prefix-icon=" " align="right" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"> </el-date-picker>
          </el-form-item>
          <el-form-item style="margin-left: -10px">
            <el-button class="lightBlueBtn searchBtn" type="primary" size="small" @click="search()">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table">
        <el-table ref="refTable" header-cell-class-name="h_bg" :data="tableData" style="width: 100%">
          <el-table-column prop="pername" label="姓名" width="70" align="center"> </el-table-column>
          <el-table-column prop="dep_id" label="项目" align="center"> </el-table-column>
          <el-table-column prop="roles" label="岗位" align="center"> </el-table-column>
          <el-table-column prop="sex" label="性别" align="center"> </el-table-column>
          <el-table-column prop="province" label="籍贯" align="center"> </el-table-column>
          <el-table-column prop="birthday" label="生日" align="center"> </el-table-column>
          <el-table-column label="年龄" align="center">
            <template slot-scope="scope">
              <div>
                {{ scope.row.birthday | getAge }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="contact" width="158" label="手机号" align="center"> </el-table-column>
          <el-table-column prop="cardid" width="200" label="身份证号" align="center"> </el-table-column>
          <el-table-column prop="inday" label="入职日期" align="center"> </el-table-column>
          <el-table-column prop="lzday" label="离职时间" align="center"> </el-table-column>
          <!-- <el-table-column label="司龄" align="center">
            <template slot-scope="scope">
              <div>
                {{ scope.row.inday | dateSubMonth }}
              </div>
            </template>
          </el-table-column> -->
          <el-table-column label="离职原因" align="center">
            <template slot-scope="scope">
              <div>
                <span>{{ scope.row.lzcase }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="转其他" align="center">
            <template slot-scope="scope">
              <div>
                <span class="select" @click="show(scope.row.id)">转入其他</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="158">
            <template slot-scope="scope">
              <div class="table_btns">
                <el-button size="mini" @click="$router.push({ name: 'resignDetail', params: { id: scope.row.id } })">查看</el-button>
                <el-button size="mini" @click="reduction(scope.row.id)" class="warning">还原</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination_box">
          <el-pagination @current-change="handleCurrentChange" :current-page="queryInfo.pageNum" :page-size="queryInfo.pageSize" layout="total, prev, pager, next,jumper" :total="total" background> </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog class="auditionDialog" ref="auditionDialog" :modal="false" title="转其他类型" destroy-on-close :visible.sync="auditionDialog" width="320px">
      <el-form ref="audition" :rules="rules" :model="auditionData" label-width="90px">
        <el-form-item label="类型" prop="zty">
          <el-select v-model="auditionData.zty" clearable>
            <el-option :value="5" label="黑名单"></el-option>
          </el-select>
        </el-form-item>
        <div>
          <el-form-item label="黑名单时效" prop="blacklist_duration">
            <el-select v-model="auditionData.blacklist_duration" clearable>
              <el-option value="0" label="3个月"></el-option>
              <el-option value="1" label="6个月"></el-option>
              <el-option value="2" label="1年"></el-option>
              <el-option value="3" label="2年"></el-option>
              <el-option value="4" label="3年"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="黑名单原因" prop="blacklist_reason">
            <el-input type="textarea" :rows="2" :autosize="{ minRows: 3, maxRows: 6 }" placeholder="请输入内容" v-model="auditionData.blacklist_reason"> </el-input>
          </el-form-item>
        </div>
        <el-form-item>
          <input type="text" v-model="auditionData.id" hidden />
          <el-button class="lightBlueBtn searchBtn" type="primary" size="small" @click="change()">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import { torencai } from '@/api/audition.js'
  import { getDepList } from '@/api/common.js'
  import { getResignPersonnel, reductionPersonnel } from '@/api/personnelList'
  import HearderTitle from '@/components/HearderTitle'
  import pageCacheMix from '@/mixins/pageCacheMix'
  import { dateSubMonth, getAge } from '@/util'
  export default {
    name: 'resignPersonnel',
    mixins: [pageCacheMix],
    data() {
      return {
        queryInfo: {
          // 姓名
          pername: '',
          // 离职时间
          lzdayet: '',
          lzdayst: '',
          // 当前页
          pageNum: 1,
          // 每页数量
          pageSize: 14,
          dep_id: '',
        },
        rules: {},
        tableData: [],
        auditionDialog: false,
        total: 0,
        datalist: [],
        defaultProps: {
          children: 'children',
          label: 'name',
        },
        auditionData: {
          zty: 5,
          id: '',
          blacklist_reason: '',
          blacklist_duration: '',
        },
      }
    },
    async created() {
      this.getResignPersonnel()
      let { data } = await getDepList()
      this.datalist = data
    },
    methods: {
      //节点点击事件
      handleClickNode(data) {
        this.queryInfo.dep_id = data.name
        // 选择器执行完成后，使其失去焦点隐藏下拉框的效果
        this.$refs.selectTree.blur()
      },
      // 获取离职人员列表
      async getResignPersonnel() {
        let { plist } = await getResignPersonnel(this.queryInfo)
        this.tableData = plist.data
        this.total = plist.total
      },
      // 搜索
      search() {
        // 页码恢复第一页
        this.queryInfo.pageNum = 1
        this.getResignPersonnel()
      },
      // 显示修改状态弹窗
      show(id) {
        this.auditionData.id = id
        this.auditionDialog = true
      },
      async change() {
        this.$refs['audition'].validate(async (valid) => {
          if (!valid) return
          if (this.auditionData.id !== '') {
            let data = this.auditionData
            data['reigin'] = 1
            let res = await torencai(data)
            if (res.status !== 200) return this.$message.error('提交失败')
            this.$message.success('提交成功')
            this.$refs['audition'].resetFields()
            this.auditionDialog = false
            return this.getResignPersonnel()
          } else {
            return this.$message.error('id不能为空')
          }
        })
      },
      // 监听当前页码的变化
      handleCurrentChange(newpagenum) {
        this.queryInfo.pageNum = newpagenum
        this.getResignPersonnel()
      },
      // 还原离职员工
      async reduction(id) {
        if (!id) return this.$message.error('请选择要还原的人员')
        const res = await this.$confirm('您确定还原改人员吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).catch((err) => err)
        if (res !== 'confirm') return this.$message.info('取消成功')
        let response = await reductionPersonnel({ id })
        if (response.status !== 200) {
          this.$message.error('还原失败')
        } else {
          this.$message.success('还原成功')
          // 删除成功后刷新页面
          this.getResignPersonnel()
        }
      },
    },
    components: { HearderTitle },
    filters: {
      // 计算年龄
      getAge(age) {
        return getAge(age)
      },
      // 计算入职时间
      dateSubMonth(date) {
        return dateSubMonth(date)
      },
    },
  }
</script>

<style lang="less">
  .resignPersonnel {
    .tableBox {
      .select {
        color: #015293;
        font-size: 12px;
        cursor: pointer;
      }
      .tool_bar {
        padding-top: 28px;
        padding-bottom: 18px;
        font-size: 14px;
        color: #888;
        .el-form-item {
          margin-right: 20px;
          margin-bottom: 0;

          .el-input__inner,
          .el-date-editor.el-input {
            width: 120px;
            height: 32px;
          }
          &:first-of-type {
            .el-input__inner {
              width: 210px;
            }
          }
          .el-date-editor.el-input {
            width: 120px;
            .el-input__inner {
              width: 120px;
            }
          }
          .el-input__inner {
            padding-left: 10px;
          }
          .middle {
            padding: 0 10px;
          }
          .searchBtn {
            width: 82px;
          }
        }
      }
      .el-table {
        min-height: 675px;
        &::before {
          height: 0;
        }
      }
    }
    .auditionDialog {
      .el-dialog__header {
        border-bottom: 1px solid #dcdfe6;
      }
      .el-dialog__body {
        padding-bottom: 0;
        overflow: hidden;
        .el-form-item {
          margin-bottom: 15px;
        }
      }
      .el-date-editor.el-input,
      .el-date-editor.el-input__inner,
      .el-textarea__inner {
        width: 178px;
      }
      .el-input__inner {
        padding-left: 15px;
        width: 178px;
      }
      .searchBtn {
        width: 112px;
      }
    }
  }
</style>
